import { Copy } from "lucide-react";
import { cn } from "@/shared/lib/utils";
import type { HttpMethod } from "../developer-api";
import { METHOD_STYLES, copyToClipboard } from "./helpers";

export function CopyButton({
  value,
  label,
  className,
}: {
  value: string;
  label: string;
  className?: string;
}) {
  return (
    <button
      type="button"
      onClick={() => copyToClipboard(value, label)}
      className={cn(
        "inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground transition-colors px-2 py-1 rounded hover:bg-muted",
        className,
      )}
      aria-label={`Copy ${label}`}
    >
      <Copy className="h-3.5 w-3.5" />
      Copy
    </button>
  );
}

export function MethodBadge({
  method,
  size = "sm",
}: {
  method: HttpMethod;
  size?: "sm" | "xs";
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center justify-center rounded font-semibold font-mono border",
        METHOD_STYLES[method],
        size === "sm" ? "px-2 py-0.5 text-[11px] w-14" : "px-1.5 py-0 text-[10px] w-12",
      )}
    >
      {method}
    </span>
  );
}
